module.exports = __webpack_public_path__ + "static/media/Boat_Club_Feast.8961c9be.pdf";